import React from 'react'

const NewWayFooter = () => {
    return (
        <footer className="front-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <ul className="front-footer-links front-footer-links-white">
                            <li><a href="#">Algemene voorwaarden</a></li>
                            <li><a href="#">Privacyverklaring</a></li>
                            <li><a href="#">Cookie verklaring</a></li>
                            <li><a href="#">Sitemap</a></li>
                            <li><a href="#">Al onze Pick up Points</a></li>
                            <li><a href="#">Word Partner</a></li>
                            <li><a href="#">Klant worden</a></li>
                            <li><a href="#">FAQs</a></li>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <div className="footer-company-info">
                            <h2>Mobility Platform B.V.</h2>
                            <a target="_blank"
                               rel="noreferrer"
                               href="https://www.google.com/maps/place/Klokkenbergweg+17,+1101+AK+Amsterdam/@52.302188,4.934703,17z/data=!3m1!4b1!4m5!3m4!1s0x47c60b9ff2cfadc3:0x788c1db66db514dd!8m2!3d52.302188!4d4.9368917?shorturl=1">
                                Klokkenbergweg 17 <br/>
                                1101 AK Amsterdam
                            </a>
                            <a href="mailto:info@kav2go.nl">info@kav2go.nl</a>
                            <a href="#">088 - 088 34 34</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default NewWayFooter
